import React from "react";

const FormError = ({ message, className = "form-error" }) => {
  if (!message) return null;

  return <div className={className}>{message}</div>;
};

export default FormError;
